import React from 'react';
import AlertGoogleHotelAdsFbl from './AlertGoogleHotelAdsFbl';
import {useParams} from "react-router-dom";
import {APP_ALERT_CENTER_API_ENDPOINT} from "../../../../constants/api_urls";
import { getUserToken } from "utils/functions/userToken";

const AlertMetasearchGoogleForm = ({alertData, actionType, onClose, showSnackbar, refreshData}) => {

    const { idaccount } = useParams();
    const availableSegments = ["DEVICE", "MARKET"];
    let method = 'POST';
    let apiActionEndpoint = '';
    const apiEndpoint = `${APP_ALERT_CENTER_API_ENDPOINT}/api/alert-center-metrics/google-hotel-ads-fbl/metrics-list`;
    if(actionType === 'edit') {
        method = 'PUT';
        apiActionEndpoint = `${APP_ALERT_CENTER_API_ENDPOINT}/api/alert-center-metrics/google-hotel-ads-fbl/edit/${idaccount}/` + alertData.id;
    }
    else {
        apiActionEndpoint = `${APP_ALERT_CENTER_API_ENDPOINT}/api/alert-center-metrics/google-hotel-ads-fbl/add/${idaccount}`;
    }

    const jwtToken = getUserToken();

    const submitGoogleGhaFblAlert = (requestBody) => {
        fetch(apiActionEndpoint, {
            method: method,
            headers: {
                'Authorization': `Bearer ${jwtToken}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestBody),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
            })
            .then((result) => {
                showSnackbar('Alert saved successfully');
                if (refreshData) {
                    refreshData();
                }
                onClose();
            })
            .catch((error) => {
                console.error('Error saving alert:', error);
                showSnackbar('Error saving alert' + error.message, 'error');
            });
    };

    return (
        <div>
            <AlertGoogleHotelAdsFbl
                apiEndpoint={apiEndpoint}
                actionType={actionType}
                alertData={alertData}
                jwtToken={jwtToken}
                showSnackbar={showSnackbar}
                submitCallback={submitGoogleGhaFblAlert}
                availableSegments={availableSegments}
                onClose={onClose}
            />
        </div>
    );
};

export default AlertMetasearchGoogleForm;
